<template>
  <lay-row>
    <lay-col md="16" md-offset="4">
      <lay-input prefix-icon="layui-icon-search" fluid style="margin-top: 20px;" v-model="keyWorld" placeholder="输入搜索名称" @input="change">
        <template #suffix>
          <lay-button  size="xs"  border-style="dashed" style="padding: 0 15px;" radius @click="reloadData">
            <lay-icon type="layui-icon-refresh"></lay-icon>&nbsp;刷新时间：&nbsp;{{updateTime}}
          </lay-button>
        </template>
      </lay-input>
    </lay-col>
    <lay-col md="24">
      <div style="padding: 10px;">
        <lay-table  :columns="columns" even :data-source="filterDataSource" height="754px" :loading="dataSource.length == 0">
          <template #no="{ rowIndex }">
            <span>{{rowIndex + 1}}</span>
          </template>
          <template #cabinet_name="{ row }">
            <span>【{{row.cabinet_no}}】{{row.cabinet_name}}</span>
          </template>
          <template #operation="{ row }">
            <lay-button type="default" size="xs"  ><span style="padding: 0 10px"><lay-icon type="layui-icon-chart" @click="viewNodeChart({name: `【${row.cabinet_no}】${row.cabinet_name}`, location: row.location, ct: row.ct, type: row.type})"></lay-icon></span></lay-button>
          </template>
        </lay-table>
      </div>
    </lay-col>
  </lay-row>
</template>

<script setup>
import {ref, watch} from "vue";
import {useRealTimeDataService} from "@/assets/js/realTimeDataService";
import useUtils from "@/assets/js/utils";
import {useRouter} from "vue-router/dist/vue-router";
import {debounce} from "lodash";
import {useClock} from "@/assets/js/clock";
import {layer} from "@layui/layui-vue";

const router = useRouter();
const date = ref()
const keyWorld = useUtils().keyWord;
const dataSource = ref([
])
const {seconds} = useClock();
const updateTime = ref(seconds.value)

const node = ref([])

const {interrupted}  = useRealTimeDataService(service, null, {checkFR: true, dataType: 1, nodeTypes: 0});
setTimeout(interrupted, 2000)
const columns = [
  {
    title:"序号",
    width:"50px",
    key:"no",
    customSlot: "no",
    fixed: "left",
  },
  {
    title:"名称",
    width:"150px",
    key:"cabinet_name",
    ellipsisTooltip: true,
    customSlot: "cabinet_name",
    fixed: "left",
  },
  {
    title:"CT",
    width:"50px",
    key:"ct",
  },
  {
    title:"A相电流",
    width:"50px",
    key:"ia",
    ellipsisTooltip: true,
  },
  {
    title:"B相电流",
    width:"50px",
    key:"ib",
    ellipsisTooltip: true,
  },
  {
    title:"C相电流",
    width:"50px",
    key:"ic",
    ellipsisTooltip: true,
  },
  {
    title:"平均相电流",
    width:"50px",
    key:"i",
    ellipsisTooltip: true,
  },
  {
    title:"平均相电压",
    width:"50px",
    key:"u",
    ellipsisTooltip: true,
  },
  {
    title:"平均线电压",
    width:"50px",
    key:"ux",
    ellipsisTooltip: true,
  },
  {
    title:"有功功率",
    width:"50px",
    key:"p",
    ellipsisTooltip: true,

  },
  {
    title:"无功功率",
    width:"50px",
    key:"q",
    ellipsisTooltip: true,
  },
  {
    title:"功率因数",
    width:"50px",
    key:"pf",
    ellipsisTooltip: true,
  },
  {
    title:"有功电能",
    width:"50px",
    key:"w",
    ellipsisTooltip: true,
  },
  {
    title:"更新时间",
    width:"150px",
    key:"now",
    ellipsisTooltip: true,
    fixed: "right",
  },
  {
    title:"查看",
    width:"50px",
    customSlot: "operation",
    fixed: "right",
  },
]

function service(data){
  if (node.value.length == 0){
    for (let d of data){
      node.value.push(d);
    }
  }

  let dsLen = dataSource.value.length;
  if (dsLen < data.length){
    dataSource.value = data;
  }
  else {
    for (let i = 0 ; i < dsLen ; i++){
      let node = dataSource.value[i];
      for (let updateNode of data){
        if (node.location == updateNode.location){
          dataSource.value[i] = updateNode;
          break;
        }
      }
    }
  }
  change()
}

const filterDataSource = ref([])

function generateFilterData(){
  let filterData = dataSource.value;
  let kv = keyWorld.value;
  let filterConStatus = -1;
  if (kv){
    if ((kv.indexOf('无通信') != -1 && (filterConStatus = 1)) || (kv.indexOf('有通信') != -1 && (filterConStatus = 2))){
      kv = kv.replace('无通信', '').replace("有通信", '').replaceAll(" ", "")
      filterConStatus = true;
    }
    filterData = filterData.filter(n => (n.cabinet_name.indexOf(kv) != -1 || n.cabinet_no.indexOf(kv) != -1) && (filterConStatus != -1 ? (n.status == filterConStatus - 1) : true));
  }

  if (filterData.length > 30 && filterConStatus == -1){
    filterData = filterData.slice(0, 30);
  }
  filterDataSource.value =  filterData;
}

const change = debounce(generateFilterData, 300, {maxWait: 2000});


watch(date, (newDate) => {
  console.log(newDate)
})

function viewNodeChart(node){
  router.push({path: '/7-1', query: node})
}

function reloadData(){
  interrupted(false);interrupted(true);
  updateTime.value = seconds.value;
  layer.msg('已刷新')
}


</script>

<style scoped>
.chart{
  height: 650px;
  padding-top: 20px;
}
.download{
  font-size: 23px;cursor: pointer;
}
.refresh{
  font-size: 18px;cursor: pointer;
}
</style>